<mat-tab-group class="mat-tab-group-principal" #protocolTabs (selectedTabChange)="onTabChange($event)">
  <mat-tab #protocolTab>

    <ng-template mat-tab-label>{{ 'protocolEdit.general.title' | translate }} </ng-template>

    <form [formGroup]="form">

      @if (protocol.id != null) {
        <mat-card class="card">
          <mat-card-content>
            <div fxFlex="100" style="text-align: end;">
              <div fxFlex="100">
                <button mat-raised-button color="primary" (click)="showAdjustTemplate()">{{
                'button.adjustTemplate' | translate }}</button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }

      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'protocolEdit.general.title' | translate }}
          </mat-toolbar>

          <div fxLayout="row" class="flexwrap">

            <div fxFlex="50" fxFlex.lt-md="100%">
              <div fxLayout="column">
                <div fxLayout="row" class="flexwrap">
                  <div fxFlex="50" fxFlex.lt-md="100%">
                    <div fxLayout="column" class="flexwrap">
                      <div fxFlex="100" fxFlex.lt-md="100%">
                        <div fxLayout="row" class="flexwrap">
                          <div fxFlex="80">
                            <mat-form-field class="full-width">
                              <mat-label>{{ 'protocolEdit.general.documentCode.label' | translate }}</mat-label>
                              <input matInput formControlName="documentCode" required
                                [(ngModel)]="protocol.documentCode"
                                [errorStateMatcher]="matcher">
                              <mat-error>
                                {{ 'protocolEdit.general.documentCode.error' | translate}}
                              </mat-error>
                            </mat-form-field>
                          </div>
                          @if (canEditDocumentCode()) {
                            <div fxFlex="20">
                              <button mat-icon-button (click)="editDocumentCode()">
                                <mat-icon>mode_edit</mat-icon>
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>

                  <div fxFlex="50" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.general.client.label' | translate }}</mat-label>
                      <mat-select #clientSelect required formControlName="idClient"
                        [(ngModel)]="protocol.idClient"
                        [disabled]="+protocol.signedVersion > 0">
                        @if (clientSelect.focused) {
                          <mat-select-filter [displayMember]="'name'"
                            [array]="clients" (filteredReturn)="clientsFiltered =$event"
                            [noResultsMessage]="'common.noResults' | translate"
                            [placeholder]="'common.selectFilterPlaceholder' | translate">
                          </mat-select-filter>
                        }
                        @for (client of clientsFiltered; track client) {
                          <mat-option [value]="client.id">
                            {{ client.name }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-error>
                        {{ 'protocolEdit.general.client.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div fxFlex="50" fxFlex.lt-md="100%">
                    <!--<mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.general.process.label' | translate }}</mat-label>
                    <mat-select required formControlName="idProcess" disabled="true"
                      [(ngModel)]="protocol.idProcess">
                      <mat-option>--</mat-option>
                      <mat-option *ngFor="let item of processes" [value]="item.id">
                        {{ 'processType.' + item.translation | translate }}
                      </mat-option>
                    </mat-select>
                    <mat-error>
                      {{ 'protocolEdit.general.process.error' | translate }}
                    </mat-error>
                  </mat-form-field>-->
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.general.clientDocumentCode.label' | translate }}</mat-label>
                    <input matInput formControlName="clientDocumentCode"
                      [(ngModel)]="protocol.clientDocumentCode"
                      [errorStateMatcher]="matcher">
                  </mat-form-field>
                </div>

                <div fxFlex="50" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.general.projectNo.label' | translate }}</mat-label>
                    <input matInput formControlName="projectNo" [(ngModel)]="protocol.projectNo"
                      required [errorStateMatcher]="matcher">
                    <mat-error>
                      {{ 'protocolEdit.general.projectNo.label' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex="50" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.general.projectManager.label' | translate }}</mat-label>
                    <mat-select formControlName="projectManager"
                      [(ngModel)]="protocol.usernameProjectManager">
                      <mat-option>--</mat-option>
                      @for (item of respField; track item) {
                        <mat-option [value]="item.username">
                          {{ item.fullName }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex="50" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.general.test.label' | translate }}</mat-label>
                    <mat-select #selectTestPerformed [ngModelOptions]="{standalone: true}"
                      name="testPerformed" [(ngModel)]="protocol.testPerformed" multiple
                      (selectionChange)="onSelectedTestCheckbox($event)">
                      @for (item of testsPerformed; track item) {
                        <mat-option
                          [value]="item.description"
                          [disabled]="disabledOptionTest(item.description)">
                          {{ 'testQualification.title.' + item.description | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- <div fxFlex="100">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'protocolEdit.general.department.label' | translate }}</mat-label>
                  <input matInput formControlName="department" name="department" [(ngModel)]="protocol.department" [disabled]="true">
                </mat-form-field>
              </div>-->
            </div>

          </div>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100%">
          <div fxLayout="column">

            <div fxLayout="row" class="flexwrap">
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'protocolEdit.general.regUser.label' | translate }}</mat-label>
                  <input matInput formControlName="regUser" [(ngModel)]="protocol.regUser">
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'protocolEdit.general.modUser.label' | translate }}</mat-label>
                  <input matInput formControlName="modUser" [(ngModel)]="protocol.modUser">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" class="flexwrap">
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'protocolEdit.general.regFc.label' | translate }}</mat-label>
                  <input matInput formControlName="regFc" [ngModel]="protocol.regFc | fixDate">
                </mat-form-field>
              </div>
              <div fxFlex="50" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'protocolEdit.general.modFc.label' | translate }}</mat-label>
                  <input matInput formControlName="modFc" [ngModel]="protocol.modFc | fixDate">
                </mat-form-field>
              </div>
            </div>

            <div fxLayout="row" class="flexwrap">
              @if (protocol.statusTranslation != null) {
                <div fxFlex="50" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.general.status.label' | translate }}</mat-label>
                    <input matInput name="status" disabled  value="{{ 'protocolStatus.' + protocol.statusTranslation | translate }}">
                  </mat-form-field>
                </div>
              }
              @if (protocol.currentVersion != 0 && protocol.currentVersion != null) {
                <div fxFlex="50" fxFlex.lt-md="100%"
                  >
                  <div fxLayout="row">
                    <div fxFlex="50">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolEdit.general.currentVersion.label' | translate }}</mat-label>
                        <input matInput formControlName="currentVersion"
                          [ngModel]="protocol.currentVersion">
                      </mat-form-field>
                    </div>
                    <div fxFlex="50">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolEdit.general.signedVersion.label' | translate }}</mat-label>
                        <input matInput formControlName="signedVersion"
                          [ngModel]="protocol.signedVersion">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

      </div>

    </mat-card-content>
  </mat-card>

  <mat-card class="card">
    <mat-card-content>
      <mat-toolbar color="secondary">
        {{ 'protocolEdit.referenceDocs.title' | translate }}

        <button mat-icon-button color="accent" (click)="openNewRefDoc()">
          <mat-icon>add</mat-icon>
        </button>
      </mat-toolbar>

      <br />

      <div fxLayout="row">

        <div fxFlex fxFlex.lt-md="100%">

          <table mat-table matSort #refDocTable [dataSource]="protocol.referenceDocs"
            style="width: 95%;">

            <!-- code Column -->
            <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'protocolEdit.referenceDocs.code.label' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.code }} </td>
            </ng-container>

            <!-- name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'protocolEdit.referenceDocs.name.label' | translate }}
              </th>
              <td mat-cell *matCellDef="let item" style="white-space: pre;"> {{ item.name }} </td>
            </ng-container>

            <!-- Button edit Column -->
            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
              <td mat-cell *matCellDef="let element; let refDocIndex = index">
                <button mat-icon-button (click)="editRefDoc(refDocIndex)">
                  <mat-icon>mode_edit</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Button delete Column -->
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
              <td mat-cell *matCellDef="let element; let refDocIndex = index">
                <button mat-icon-button (click)="removeRefDoc(refDocIndex)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColsRefDoc"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColsRefDoc;"></tr>

          </table>

        </div>

      </div>

    </mat-card-content>

  </mat-card>
  <mat-card class="card">
    <mat-card-content>
      <br />

      <mat-toolbar color="secondary">
        {{ 'protocolEdit.equipment.title' | translate }}

        @if (protocol.equipments != null && protocol.equipments.length === 0) {
          <button mat-icon-button color="accent" (click)="openDialogEquipment()"
            >
            <mat-icon>add</mat-icon>
          </button>
        }
      </mat-toolbar>

      <!-- equipos area -->
      <mat-accordion>
        @for (equipment of protocol.equipments; track equipment; let indexEquipment = $index) {
          <mat-expansion-panel class="overflowX"
            (afterExpand)="equipmentTab = indexEquipment" (closed)="equipmentTab = null">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div style="margin: auto 0;display: block;">
                  {{ equipment.equipment }}
                  -
                  {{ equipment.model }}({{ equipment.serialNumber }})
                </div>
                @if (equipmentTab === indexEquipment) {
                  <button mat-icon-button color="accent"
                    (click)="openDialogEditEquipment(indexEquipment)" [disabled]="disabledSigned()">
                    <mat-icon style="font-size: 20px;">mode_edit</mat-icon>
                  </button>
                }
                @if (equipmentTab === indexEquipment) {
                  <button mat-icon-button color="accent"
                    (click)="deleteEquipment(indexEquipment)" [disabled]="disabledSigned()">
                    <mat-icon style="font-size: 20px;">delete</mat-icon>
                  </button>
                }
                @if (equipmentTab === indexEquipment && false) {
                  <button mat-icon-button color="accent"
                    (click)="duplicateEquipment(indexEquipment)" [disabled]="disabledSigned()">
                  </button>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-card-content>
  </mat-card>

  @if (protocol.id != null && protocol.equipments.length > 0) {
    <mat-card class="card">
      <mat-card-content>
        <mat-toolbar color="secondary">
          {{ 'protocolEdit.testQualification.title' | translate }}
        </mat-toolbar>
        @for (test of testQualificationTypeList; track test; let indexTest = $index) {
          <div fxLayout="column" class="flexwrap"
            >
            <div fxLayout="column">
              @if (test.idQualificationType != 4) {
                <div [id]="'title'+indexTest" fxFlex="100"
                  >
                  <span style="font-weight: 600;">{{'testQualification.title.' + test.qualificationType |
                  translate}}</span>
                </div>
              }
              @for (item of test.testQTypes; track item; let indexItem = $index) {
                <div fxFlex="100">
                  <mat-checkbox #checkTest [id]="'checkboxId'+indexTest+indexItem" [disabled]="disabledSigned()"
                    [(ngModel)]="item.checked" [ngModelOptions]="{standalone: true}"
                    (change)="onSelectedItem(item, test, $event)">
                    <span>
                      {{ !item.name ? ('testQualification.' + item.translation | translate) : item.name }}
                    </span>
                  </mat-checkbox>
                  @if (item.checked  && protocol.id != null) {
                    <button mat-raised-button
                      (click)="createTestsSelected(indexItem, item)" style="box-shadow: none !important" class="btn-open-verification">
                      <mat-icon fxHide.lt-sm
                      [ngStyle]="item.checked && isCompletedTest(item.id) ? {'color': 'green'} : {'color': 'none'}">display_settings</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        }
      </mat-card-content>
    </mat-card>
  }

  <app-protocol-q-edit-attachments #attachmentsComponent>
  </app-protocol-q-edit-attachments>

  <mat-card class="card">
    <mat-card-actions>
      <div fxFlex></div>
      <!--<button mat-raised-button color="primary" *ngIf="showRevertSign()" (click)="revertSign()">
    {{ 'button.revertSign' | translate }} </button>-->
    <button mat-raised-button color="primary" (click)="saveProtocol()" [disabled]="disabledSigned()">
    {{ 'button.save' | translate}}</button>
    <div fxFlex="5px"></div>
    <div matTooltip="{{ 'button.disabled.offline' | translate }}">
      @if (showManualSign()) {
        <button mat-raised-button color="primary" [disabled]="disabledSigned()" (click)="manualSign()">
          {{ 'button.sign-manual' | translate }}
        </button>
      }
    </div>
    <div fxFlex="5px"></div>
    @if (showAutomaticSign()) {
      <button mat-raised-button color="primary" (click)="prepareToSign()">
        {{ 'button.sign-automatic' | translate }}
      </button>
    }
    <div fxFlex="5px"></div>
    @if (showAutomaticSign()) {
      <button mat-raised-button color="primary" (click)="refuseSign()">
        {{ 'button.refuse' | translate }}
      </button>
    }
    <div fxFlex="5px"></div>
    @if (showSignature()) {
      <button mat-raised-button color="primary" (click)="prepareToSigner()">
        {{ 'button.manageSign' | translate }}
      </button>
    }
    <div fxFlex="5px"></div>
    @if (protocol.documentCode != null) {
      <button mat-raised-button color="accent"
        (click)="validateBeforeDownload()">{{ 'button.generateDoc' | translate }}
      </button>
    }
    <div fxFlex="5px"></div>
    <button mat-raised-button color="secondary" (click)="cancel()">{{ 'button.cancel' | translate}}
    </button>
  </mat-card-actions>
</mat-card>
</form>
</mat-tab>
@if (protocol.id != null) {
  <mat-tab #auditTab label="{{ 'protocolEdit.historical.title' | translate }}">
    <app-protocol-q-edit-audit [idProtocol]="protocol.id" [documentCode]="protocol.documentCode">
    </app-protocol-q-edit-audit>
  </mat-tab>
}

</mat-tab-group>